









































import BackButton from '@front-app/components/buttons/BackButton.vue';
import Vue from '@front-app/vendor/vue';
import { Size } from '@front-app/components/constants';
import { defineComponent, PropType } from '@vue/composition-api';
import PaddedContent from './PaddedContent.vue';

export default defineComponent({
	components: {
		PaddedContent,
		BackButton,
	},
	props: {
		size: {
			type: String as PropType<Size>,
			required: false,
			default: Size.LARGE,
		},
		headerTag: {
			type: [String, Object] as PropType<string | Vue>,
			default: 'div',
		},
		backTo: {
			type: [Object, Boolean] as PropType<Location | false>,
			required: false,
			default: false,
		},
		backLabel: {
			type: String,
			required: false,
			default: '',
		},
		isTopHeader: Boolean,
		noHorizontalPadding: Boolean,
	},
	setup() {
		return {
			Size,
		};
	},
});
